import React from 'react';
import PropTypes from 'prop-types';
import Cleave from 'cleave.js/react';

import FormControl from 'src/app/components/FormControl/FormControl';
import 'src/app/components/FormControl/FormControl.scss';


const DateInput = React.forwardRef(({
                                      required,
                                      type,
                                      value,
                                      validationMessage,
                                      markedAsWrong,
                                      focus,
                                      apiError,
                                      label,
                                      disabled,
                                      onInit,
                                      ...other
                                    }, ref) =>
  (<FormControl {
                  ...{
                    value,
                    validationMessage,
                    markedAsWrong,
                    focus,
                    apiError,
                    label,
                    disabled,
                    fixed: true
                  }
                }
  >
    <Cleave styleName="form-control__date-input"
            onInit={ onInit }
            options={ {
              date: true,
              datePattern: ['m', 'Y']
            } }
            placeholder="MM/RRRR"
            value={ value }
            type="tel"
            { ...{ required, ref, disabled } }
            { ...other }
    />
  </FormControl>));

DateInput.propTypes = {
  required: PropTypes.bool,
  type: PropTypes.string,
  other: PropTypes.object // eslint-disable-line react/forbid-prop-types
};

DateInput.defaultProps = {
  required: false,
  type: '',
  other: {}
};

export default DateInput;
